// Module
var code = "<div class=\"dms-helptext-content\">\n    <i class=\"far fa-question-circle fa-2x fa-pull-right\"></i>\n    #= data #\n</div>";
// Exports
export default code;